module.exports = __webpack_public_path__ + "static/media/25.18756386.jpeg";